import { Navigate, Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import { TasksPage } from './TasksPage';
import { TaskFormPage } from './TaskFormPage';
import { AppointmentsPage } from './AppointmentsPage';
import { AppointmentFormPage } from './AppointmentFormPage';
import { AppointmentTypesPage } from './AppointmentTypesPage';
import type { BackofficeModule } from '../registry';

/**
 * Einstiegspunkt des Moduls „Termine und Aufgaben“ im Backoffice. Alles dazu liegt in diesem Ordner. Das Backoffice kennt nur
 * diese Datei (siehe registry.tsx). Die Verträge zur API stehen in packages/shared/src/calendar. Aufgaben sind eine Liste, Termine ein
 * Kalender, beide stehen als Reiter nebeneinander.
 */
export const calendarModule: BackofficeModule = {
  key: 'calendar',
  path: '/kalender',
  // Aufgaben und Kalender stehen getrennt in der Seitenleiste
  nav: [
    { label: 'Aufgaben', path: '/kalender/aufgaben' },
    { label: 'Kalender & Termine', path: '/kalender/termine' },
  ],
  // Die Terminarten pflegt der Mandant in der Einrichtung, sie setzen das lizenzierte Modul voraus
  setupSections: [
    {
      path: 'terminarten',
      label: 'Termin- und Aufgabenarten',
      module: 'setup',
      permission: 'setup.read',
      requires: 'calendar',
      description: 'Welche Arten von Terminen und Aufgaben Ihr Unternehmen hat, zum Beispiel Meeting, Kundentermin oder Workshop. Die Farbe gilt im Kalender.',
      built: true,
      group: 'team',
      keywords: ['Terminart', 'Aufgabentyp', 'Farbe'],
    },
  ],
  setupRoutes: <Route path="terminarten" element={<ModuleGate module="setup" permission="setup.read"><AppointmentTypesPage /></ModuleGate>} />,
  routes: (
    <>
      <Route path="kalender" element={<Navigate to="/kalender/aufgaben" replace />} />
      <Route path="kalender/aufgaben" element={<ModuleGate module="calendar" permission="calendar.read"><TasksPage /></ModuleGate>} />
      <Route path="kalender/aufgaben/neu" element={<ModuleGate module="calendar" permission="calendar.write"><TaskFormPage /></ModuleGate>} />
      <Route path="kalender/aufgaben/:id" element={<ModuleGate module="calendar" permission="calendar.read"><TaskFormPage /></ModuleGate>} />
      <Route path="kalender/termine" element={<ModuleGate module="calendar" permission="calendar.read"><AppointmentsPage /></ModuleGate>} />
      <Route path="kalender/termine/neu" element={<ModuleGate module="calendar" permission="calendar.read"><AppointmentFormPage /></ModuleGate>} />
      <Route path="kalender/termine/:id" element={<ModuleGate module="calendar" permission="calendar.read"><AppointmentFormPage /></ModuleGate>} />
    </>
  ),
};
